import { Checkbox, Grid, List, ListItem, ListItemIcon, ListItemText, Paper } from "@material-ui/core";
import DataSearchBar from "components/DataSearchBar";
import { orderBy } from "lodash";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import FilterService from "services/filterService";
import Authorize from "../../../../components/Authorize";
import { permissionProfiles } from "../../../../components/Authorize/permissionProfiles";
import CustomInput from "../../../../components/CustomInput";
import { useGetLotsQuery } from "../../../lots/lotSlice";
import configStyles from "../configStyles";
import { washRateTypes } from "./enums";
import { addSelectedLot, removeSelectedLot } from "./WashSlaSlice";

const useStyles = configStyles;

export const WashLots = ({ washConfigParams, clientLots, washPricesPerLot, onConfigChange }) => {
    const classes = useStyles();
    let { data: lots, error: lotError, isLoading: isLoadingLots } = useGetLotsQuery();
    lots = lots || [];
    const { bulkEdit, selectedLots } = useSelector(state => state.washConfigState);
    const dispatch = useDispatch();

    const [search, setSearch] = useState();

    const onWashPriceChange = (lotId, newPrice) => {
        let updatedPrices = washPricesPerLot?.filter(washPrice => washPrice.lotId != lotId).map(x => ({ lotId: x.lotId, price: x.price })) ?? [];
        updatedPrices.push({ lotId: lotId, price: parseInt(newPrice) });

        onConfigChange(undefined, "washPrices", updatedPrices)
    };

    let activeLots = [];

    clientLots?.map(clientLot => {
        let lot = lots?.find(lot => lot?.id == clientLot.lotId);
        if (lot) {
            activeLots = ([...activeLots, { id: lot?.id, name: lot?.name, washPrice: lot?.washPrice, useWashProgram: clientLot?.useWashProgram, clientId: clientLot?.clientId }]);
        }
    })

    const onSelectRow = (selected, row) => {  
        if (selected) {
            dispatch(addSelectedLot(row.id));
        } else {
            dispatch(removeSelectedLot(row.id));
        }        
    }

    activeLots = orderBy(FilterService.filter([], search, activeLots, {}), ['name'], ['asc']);

    return (
        <div style={{ flex: 1, width: '100%', minHeight: 200 }}>
            <Grid container item xs={6}>
                <DataSearchBar onSearch={(val) => setSearch(val)} searchVal={search} />
            </Grid>
            <List>
                {
                    activeLots?.map((activeLot, index) => (
                        <Paper className={classes.listItem}>
                            <ListItem className={classes.spacing}>
                                <ListItemIcon className={classes.icon}>
                                    {bulkEdit && (
                                        <Checkbox
                                            checked={selectedLots.includes(activeLot?.id)||false}
                                            onChange={(e, value) => onSelectRow(value, activeLot)}
                                        />
                                    )}
                                    {!bulkEdit && <img src="/icons/icon-parking.svg" />}
                                </ListItemIcon>
                                <ListItemText primary={activeLot.name} />
                                <div className={classes.prices}>
                                    <Authorize profile={permissionProfiles.CLIENT_CONFIG.CLIENT_CONFIG_PRICING}>
                                        <ListItemText
                                            className={classes.prices}
                                            secondary={
                                                activeLot.washPrice ? `Wash Cost: $${activeLot.washPrice}` : null
                                            }
                                        />
                                    </Authorize>
                                    <div className={classes.washPriceField}>
                                        <LotPrice
                                            onWashPriceChange={onWashPriceChange}
                                            washPricesPerLot={washPricesPerLot}
                                            washConfigParams={washConfigParams}
                                            activeLot={activeLot}
                                        />
                                    </div>
                                </div>
                            </ListItem>
                        </Paper>
                    ))
                }
            </List>                    
    </div>
    )
}

const LotPrice = ({ washConfigParams, washPricesPerLot, activeLot, onWashPriceChange, disabled }) => {

    let price = washConfigParams?.rateType == washRateTypes.FLAT_RATE ?
        washPricesPerLot?.find(washPrice => washPrice.lotId == activeLot.id)?.price :
        (activeLot?.washPrice * (100 + washConfigParams?.washMargin) / 100);
    let priceWithDollar = price ? `Charge: $${price}` : '';

    return (
        <div>{(disabled || washConfigParams?.rateType == washRateTypes.MARGIN) ? priceWithDollar :
            <CustomInput
                numberOnly
                id="price"
                label='Charge'
                disabled={!washConfigParams?.useWashProgram}
                value={price}
                onChange={val => onWashPriceChange(activeLot.id, +val)}
                elementType='input'
                InputLabelProps={{
                    shrink: true,
                }}
            />}
        </div>
    )
}
